/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: hEgWOAymJgYc
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicButtonPrimary.module.css"; // plasmic-import: hEgWOAymJgYc/css
import image14CucScRsbMvBs from "./images/image14.svg"; // plasmic-import: cucScRsbMvBs/picture

createPlasmicElementProxy;

export const PlasmicButtonPrimary__VariantProps = new Array(
  "color",
  "ststus",
  "size"
);

export const PlasmicButtonPrimary__ArgProps = new Array(
  "showIcon",
  "onClick",
  "type",
  "disabled",
  "name",
  "content",
  "children"
);

const $$ = {};

function PlasmicButtonPrimary__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          showIcon: false,
          type: "button",
          disabled: false,
          content: "button"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.color
      },
      {
        path: "ststus",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.ststus
      },
      {
        path: "size",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.size
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <button
      data-plasmic-name={"globalBlue"}
      data-plasmic-override={overrides.globalBlue}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.globalBlue,
        {
          [sty.globalBluecolor_brand]: hasVariant($state, "color", "brand"),
          [sty.globalBluecolor_dark]: hasVariant($state, "color", "dark"),
          [sty.globalBluecolor_greyTwo]: hasVariant($state, "color", "greyTwo"),
          [sty.globalBluecolor_supaLight]: hasVariant(
            $state,
            "color",
            "supaLight"
          ),
          [sty.globalBluesize_medium]: hasVariant($state, "size", "medium"),
          [sty.globalBluesize_small]: hasVariant($state, "size", "small"),
          [sty.globalBlueststus_inactiveBrand]: hasVariant(
            $state,
            "ststus",
            "inactiveBrand"
          ),
          [sty.globalBlueststus_inactiveMonochrome]: hasVariant(
            $state,
            "ststus",
            "inactiveMonochrome"
          ),
          [sty.globalBlueststus_inactiveOnBackground]: hasVariant(
            $state,
            "ststus",
            "inactiveOnBackground"
          )
        }
      )}
      disabled={(() => {
        try {
          return $props.disabled;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      name={(() => {
        try {
          return $props.name;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      onClick={async event => {
        const $steps = {};
        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
      ref={ref => {
        $refs["globalBlue"] = ref;
      }}
      type={(() => {
        try {
          return $props.type;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    >
      <div
        data-plasmic-name={"text"}
        data-plasmic-override={overrides.text}
        className={classNames(projectcss.all, projectcss.__wab_text, sty.text, {
          [sty.textcolor_greyTwo]: hasVariant($state, "color", "greyTwo"),
          [sty.textcolor_supaLight]: hasVariant($state, "color", "supaLight"),
          [sty.textststus_inactiveMonochrome]: hasVariant(
            $state,
            "ststus",
            "inactiveMonochrome"
          ),
          [sty.textststus_inactiveOnBackground]: hasVariant(
            $state,
            "ststus",
            "inactiveOnBackground"
          )
        })}
      >
        <React.Fragment>
          {(() => {
            try {
              return $props.content;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return "continue";
              }
              throw e;
            }
          })()}
        </React.Fragment>
      </div>
      {(() => {
        try {
          return $props.showIcon;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return true;
          }
          throw e;
        }
      })()
        ? renderPlasmicSlot({
            defaultContents: (
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__wp8He)}
                displayHeight={"auto"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"auto"}
                loading={"lazy"}
                src={{
                  src: image14CucScRsbMvBs,
                  fullWidth: 20,
                  fullHeight: 20,
                  aspectRatio: undefined
                }}
              />
            ),

            value: args.children
          })
        : null}
    </button>
  );
}

const PlasmicDescendants = {
  globalBlue: ["globalBlue", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonPrimary__ArgProps,
          internalVariantPropNames: PlasmicButtonPrimary__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonPrimary__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "globalBlue") {
    func.displayName = "PlasmicButtonPrimary";
  } else {
    func.displayName = `PlasmicButtonPrimary.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonPrimary = Object.assign(
  // Top-level PlasmicButtonPrimary renders the root element
  makeNodeComponent("globalBlue"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicButtonPrimary
    internalVariantProps: PlasmicButtonPrimary__VariantProps,
    internalArgProps: PlasmicButtonPrimary__ArgProps
  }
);

export default PlasmicButtonPrimary;
/* prettier-ignore-end */
